import { isDefined } from '@sgme/fp';
import type { DealSplitRowModel } from 'components/common-form/builder/form/node/field/DealSplit/types';
import { useDealSplitValueDatePresets } from 'components/common-form/builder/form/node/field/DealSplit/useDealSplitValueDatePresets';
import {
  EMPTY_INDEPENDENT_AMOUNT,
  hasIndependentAmountValues,
} from 'components/common-form/builder/form/node/field/DealSplit/utils';
import { MonoDatePickerWithCustomPreset } from 'components/shared/DatePicker';
import type { DealSplitIndependentAmount } from 'models/forms/DealSplitData';
import { FC } from 'react';

type Props = {
  row: DealSplitRowModel;
  rowIndex: number;
  tradeDate?: Nullable<string>;
  isReadonly?: boolean;
  onRowIndependentAmountChanged?: (rowIndex: number, independentAmount?: DealSplitIndependentAmount) => void;
};

export const DealSplitIAValueDateCell: FC<Props> = ({
  row,
  rowIndex,
  tradeDate,
  isReadonly,
  onRowIndependentAmountChanged,
}) => {
  const { valueDatePresets, valueDatePresetTranslations } = useDealSplitValueDatePresets(tradeDate);
  const rowHasIndependentAmount = hasIndependentAmountValues(row.independentAmount);
  const currentIndependentAmount = row.independentAmount ?? EMPTY_INDEPENDENT_AMOUNT;
  const currentType = currentIndependentAmount.Type ?? 'Percentage';

  if (!rowHasIndependentAmount) {
    return null;
  }

  return (
    <MonoDatePickerWithCustomPreset
      id={`dealSplit-ia-valueDate-${rowIndex}`}
      value={currentIndependentAmount.ValueDate ?? undefined}
      onChange={value => {
        onRowIndependentAmountChanged?.(rowIndex, {
          ...currentIndependentAmount,
          Type: currentType,
          Value: currentIndependentAmount.Value,
          ValueDate: isDefined(value) ? value : undefined,
        });
      }}
      allowWeekend
      isClearable
      align="end"
      datePresets={valueDatePresets}
      datePresetTranslations={valueDatePresetTranslations}
      disabled={isReadonly ?? false}
    />
  );
};
